@if (this.highlightForm().length > 0 || this.preFilters().length > 0) {
  <cam-card>
    <cam-card-content>
      <div class="highlight-filter">
        <cam-font-icon class="highlight-filter__icon" name="filter-tool" type="sm"></cam-font-icon>
        @if (this.preFilters().length > 0) {
          <div class="highlight-filter__prefilters">
            @for (preFilter of this.preFilters(); track preFilter.label) {
              <cam-badge
                class="pointer"
                [type]="this.activePreFilter === preFilter ? 'default' : 'secondary'"
                [value]="preFilter.label"
                size="sm"
                (clickAction)="this.selectPreFilter(preFilter)"
              ></cam-badge>
            }
          </div>
        }
        @if (this.highlightForm().length > 0) {
          <div class="highlight-filter__body">
            <cam-form
              class="flex-full"
              [inputs]="this.highlightForm()"
              [canDisplayButton]="false"
              [onLive]="this.liveFilter()"
              [askValidation$]="this.askValidation$"
              (valid)="this.filtersSelected($event)"
            ></cam-form>
            <div class="highlight-filter__actions">
              @if (this.showClearButton()) {
                <cam-button size="small" type="secondary" (action)="this.clear()">
                  {{ 'core.filter.clear' | translate }}
                </cam-button>
              }
              @if (!this.liveFilter()) {
                <cam-button size="small" type="secondary" (action)="this.submit()">
                  {{ 'core.filter.validate' | translate }}
                </cam-button>
              }
            </div>
          </div>
        }
      </div>
    </cam-card-content>
  </cam-card>
}
